// side effect: fetch new lightProfile simulation when decisions are made
import {fetchProfileResult, setProfile, resetCustomUpload} from '../slices/lightProfileSlice';
import buildConfiguration from '../components/lightProfile/profiles';
import {selectProfileId} from '../selectors';
import {setProductModel, setDecisions} from '../slices/configurationSlice';
import {fetchModels} from '../slices/productDataSlice';
import {luminaryOptions} from '../sectionConfig';
import {setStatus, setMode} from '../slices/statusSlice';
import {lightProfileToFeatureValueMap, regionToFeatureValueMap} from '../lightProfiles';
import {decision} from '../slices/decisionsSlice';

export const lightProfileMiddleware = store => next => async action => {
	const result = next(action);

	if (action.type === 'lightProfile/setBaseProfileId' || action.type === 'lightProfile/setZoneId' || action.type === 'lightProfile/fetchLightProfileLocation/fulfilled' || action.type === 'lightProfile/setProfileData' || action.type === 'lightProfile/setCentralPowerControlId') {

		// run light simulation
		const lightProfile = store.getState().lightProfile.data;
		if(lightProfile.project?.base !== null && lightProfile.project?.zone !== null  && lightProfile.project?.centralPowerControl !== null) {
			const profileId = selectProfileId(store.getState());
			//get the new lightProfile simulation
			if (profileId && lightProfile.project.location !== null && lightProfile.project.location.latitude !== null && lightProfile.project.location.longitude !== null ) {
				const profile = buildConfiguration(
					profileId,
					lightProfile.project.location.latitude,
					lightProfile.project.location.longitude,
					lightProfile.project.location.timezone,
					lightProfile.project.location.offset,
				);
				store.dispatch(setProfile(
					{
						profile: Object.assign({}, profile)
					}
				));
				store.dispatch(
					fetchProfileResult(profile)
				);

				if (lightProfile.project.luminary !== null && store.getState().productData.models.length === 0) {
					const lo = luminaryOptions.find(o => o.id === lightProfile.project.luminary);
					await store.dispatch(
						setStatus({
							productFamily: lo.family
						})
					);
					await store.dispatch(
						setMode({mode: 'external'})
					);

				}
			}
		}
	}
	if (action.type === 'lightProfile/setZoneId') {
		store.dispatch(resetCustomUpload());
	}

	if (action.type === 'lightProfile/setBaseProfileId') {
		store.dispatch(resetCustomUpload());
		const lightProfile = store.getState().lightProfile.data;
		const region = store.getState().status.region;
		const lo = luminaryOptions.find(o => o.id === lightProfile.project.luminary);
		if (lo && lo.availableForLightProfiles.includes(lightProfileToFeatureValueMap[lightProfile.project.base])) {
			console.log('Lightprofile available for current luminare', lo.availableForLightProfiles, lightProfile.project.luminary);
			if (lightProfile.project.luminary !== null) {
				await store.dispatch(decision(
					{
						variableId: 'HS_CircularBaseProfile',
						featureValueId: lightProfileToFeatureValueMap[lightProfile.project.base],
						state: 'Included'
					}
				)).unwrap();
			}
			await store.dispatch(setDecisions(
				{
					features: [
						{
							variableId: 'CX_Region',
							featureValues: [
								{
									featureValueId: regionToFeatureValueMap[region] ?? 'int',
									state: 'Included',
									kind: 'Explicit'
								}
							]
						},
						{
							variableId: 'HS_CircularBaseProfile',
							featureValues: [
								{
									featureValueId: lightProfileToFeatureValueMap[lightProfile.project.base],
									state: 'Included',
									kind: 'Explicit'
								}
							]
						}
					]
				}
			));
		} else {
			// find first available luminary for this lightprofile
			const possibleLuminary= luminaryOptions.find(o => o.availableForLightProfiles.includes(lightProfileToFeatureValueMap[lightProfile.project.base]));
			console.log('Lightprofile not available for current luminare', lightProfile.project.luminary, luminaryOptions, lightProfileToFeatureValueMap[lightProfile.project.base], possibleLuminary);

			await store.dispatch(
				setStatus({
					productFamily: possibleLuminary.family
				})
			);
			await store.dispatch(
				setMode({mode: 'external'})
			);

			await store.dispatch(setDecisions(
				{
					features: [
						{
							variableId: 'CX_Region',
							featureValues: [
								{
									featureValueId: regionToFeatureValueMap[region] ?? 'int',
									state: 'Included',
									kind: 'Explicit'
								}
							]
						},
						{
							variableId: 'HS_CircularBaseProfile',
							featureValues: [
								{
									featureValueId: lightProfileToFeatureValueMap[lightProfile.project.base],
									state: 'Included',
									kind: 'Explicit'
								}
							]
						}
					]
				}
			));
		}
	}

	if (action.type === 'lightProfile/setLuminaryId') {
		const lo = luminaryOptions.find(o => o.id === action.payload.id);
		const lightProfile = store.getState().lightProfile.data;
		const region = store.getState().status.region;

		await store.dispatch(
			setStatus({
				productFamily: lo.family,
			})
		);
		await store.dispatch(
			setMode({mode: 'external'})
		);
		await store.dispatch(decision(
			{
				variableId: 'HS_CircularBaseProfile',
				featureValueId: lightProfileToFeatureValueMap[lightProfile.project.base],
				state: 'Included'
			}
		)).unwrap();
		store.dispatch(setDecisions(
			{
				features: [
					{
						variableId: 'CX_Region',
						featureValues: [
							{
								featureValueId: regionToFeatureValueMap[region] ?? 'int',
								state: 'Included',
								kind: 'Explicit'
							}
						]
					},
					{
						variableId: 'HS_CircularBaseProfile',
						featureValues: [
							{
								featureValueId: lightProfileToFeatureValueMap[lightProfile.project.base],
								state: 'Included',
								kind: 'Explicit'
							}
						]
					}
				]
			}
		));
	}

	return result;
};
